<style lang="less">
.task-editor {
  .l-node-selected {
    .l-node-inner {
      background: var(--primary);
      .l-node-text {
        color: var(--hover-text) !important;
        .ghost-input{
          .ivu-input-icon-clear{
            right:-30px;
            color:var(--hover-text);
            top:-2px;
          }
          input{
            color:var(--hover-text);
            min-width:80px;

          }

          input::placeholder{
            color:var(--hover-text);
          }
        }
      }

      .l-node-sub-list {
        background: var(--bg2);
      }
    }

    .l-node-text {
      background: none;
    }
  }

  .l-node-selected + .l-node-sub-list {
    .l-node-inner {
      background: var(--bg2);
      .l-node-text {
        background: none !important;
      }
    }
  }
}
</style>
<template>
  <AppLeft :collapse="!is_ready">
    <div class="flex-wrap" style="height: 40px; padding: 0 10px">
      <Input search size="small" clearable v-model="search_text" />
    </div>
    <div style="height: calc(100% - 40px); border-top: 1px solid var(--border);">
      <BaseTree
        ref="tree"
        :data="filteredTasks"
        style="height: 100%;overflow-y:auto;"
        :nodeRenderer="renderTreeNode"
        @event="handleTreeEvent"
      />
    </div>
  </AppLeft>
</template>

<script>
import AppLeft from '@/components/app/left';
import GhostInput from '@/components/app/GhostInput';
import {pick} from 'lodash';
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      search_text: '',
      edit_text: '',
      editing: false,
      nodes: [],
    };
  },
  components: {AppLeft, GhostInput},
  computed: {
    ...mapGetters('task', [
      'selected',
      'is_ready',
      'current_view',
      'computedTasks',
    ]),
    filteredTasks() {
      return this.nodes.filter((v) => {
        const search_text = this.search_text ? this.search_text.trim() : '';
        if (search_text && (!v.name || !v.name.includes(search_text))) {
          return false;
        }
        return true;
      });
    },
  },
  watch: {
    computedTasks: {
      handler(v) {
        this.nodes = this.computedTasks.map((v) =>
          pick(v, ['id', 'name', 'parent_id', 'state']),
        );
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    renderTreeNode(h, node) {
      const that = this;
      const value =
        that.editing && node.id == that.selected.id ?
          that.edit_text :
          node.name;
      const tools = node.control ?
        [] :
        [
          h('BaseIcon', {
            props: {icon: 'dot', size: '15', color: '#aaa'},
            style: 'position:absolute;right:0;',
          }),
        ];
      const nodeName = h('BaseGhostInput', {
        props: {
          value,
          maxWidth: 120,
        },
        on: {
          input: (e) => {
            that.edit_text = e;
          },
          focus: (e) => {
            this.timerFocues = setTimeout(() => {
              that.$refs.tree.draggable = false;
              that.$refs.tree.clearable = false;
              that.edit_text = e.target.value;
              that.editing = true;
            }, 200);
          },
          blur: (e) => {
            if (this.timerFocues) {
              clearTimeout(this.timerFocues);
            }
            if (false == this.editing) {
              return;
            }
            that.$refs.tree.draggable = true;
            that.$refs.tree.clearable = true;
            const value = e.target.value;
            that.editing = false;
            if (node.name !== value) {
              node.name = value;
              that.$store.commit('task/do', {
                action: 'patch',
                data: {name: value},
              });
            }
            that.edit_text = '';
          },
        },
      });
      return h(
          'div',
          {class: 'flex-wrap flex-between', style: 'height:25px;'},
          [nodeName, tools],
      );
    },
    handleTreeEvent(e) {
      if (e.type == 'select') {
        if (e.data) this.$store.commit('task/select', e.data.id);
        else this.$store.commit('task/select', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
